import { createMuiTheme } from '@material-ui/core/styles';

export const darkTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#337066',
      main: '#004d40',
      dark: '#00352c',
      contrastText: '#fff',
    },
    secondary: {
      light: '#9f3e72',
      main: '#880e4f',
      dark: '#5f0937',
      contrastText: '#000',
    },
  },
});
